import { InjectionToken } from '@angular/core';

export interface VisualisatieServiceConfig {
  VisualisatieService: {
    Url: string;
  };
}

export const VISUALISATIESERVICE_CONFIG = new InjectionToken<VisualisatieServiceConfig>('configuration VISUALISATIESERVICE');

const DEFAULT_VISUALISATIESERVICE_CONFIG: VisualisatieServiceConfig = {
  VisualisatieService: {
    Url: '',
  },
};

export function getVisualisatieServiceConfigWithDefaults(config?: VisualisatieServiceConfig): VisualisatieServiceConfig {
  return { ...DEFAULT_VISUALISATIESERVICE_CONFIG, ...config } as VisualisatieServiceConfig;
}
